import { useAccountContext } from 'utils/account/AccountContext';
import { DAMAGE_INGESTION_V2 } from 'utils/release-toggles';

const INSPECTION_DAMAGE_DATA_TYPE = 'InspectionDamage';
const INSPECTION_DAMAGE_V2_DATA_TYPE = 'InspectionDamageV2';

export const useInspectionDamageDataType = () => {
  const { hasReleaseToggle } = useAccountContext();
  return hasReleaseToggle(DAMAGE_INGESTION_V2)
    ? INSPECTION_DAMAGE_V2_DATA_TYPE
    : INSPECTION_DAMAGE_DATA_TYPE;
};
